import 'slick-carousel';
import $ from "jquery";

function portfolioSlider() {

  const projects = document.querySelectorAll('.project');

  projects.forEach((project) => {
    const sliderOne = project.querySelector('.slider_one__list');
    const sliderTwo = project.querySelector('.slider_two__list');
    let next = project.querySelector('.portfolio_next');

    $(sliderOne).slick({
      arrows: true,
      nextArrow: next,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      // adaptiveHeight: true,
      swipe: true,
      asNavFor: sliderTwo
      });
    
      $(sliderTwo).slick({
        infinite: true,
        arrows: true,
        nextArrow: next,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        // adaptiveHeight: true,
        swipe: true,
        asNavFor: sliderOne,
        focusOnSelect: true
        });
  })
  

}

export default portfolioSlider;